module.exports = __webpack_public_path__ + "img/slide4.945f1ab1.svg";